<template>
  <el-dialog title="修改" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
        <el-input type="text" v-model="formData.name" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="键值" prop="key_name" :label-width="formLabelWidth">
        <el-input type="text" v-model="formData.key_name" placeholder="请输入"></el-input>
      </el-form-item>

      <!--排序-->
      <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model="formData.sort" placeholder="请输入排序" type="number"></el-input>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="是否显示" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TypeApi from '@/api/study/type.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        name: '',
        key_name: '',
        sort: 100,
        status: 1
      },
      /*验证规则*/
      formRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        key_name: [{ required: true, message: '请输入键值', trigger: 'blur' }],
      },
      /*排序*/
      srot: 100,
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: {
    open_edit:Boolean,
    selectModel:Object,
  },
  created() {
    this.dialogVisible = this.open_edit;
    this.formData = this.selectModel;
  },
  methods: {
    /*选择分类*/
    handleChange(e) {
    },

    /*修改分类*/
    onSubmit() {
      let self = this;
      let params = self.formData;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          params.type_id = self.selectModel.type_id;
          TypeApi.edit(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success',
                });
                self.$emit('closeDialog', {
                  type: 'success',
                  openDialog: false,
                  data:params
                });
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.$emit('closeDialog', {
        type: 'error',
        openDialog: false
      });
    },
    
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/type/part/Edit.vue